import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { Modal, ModalContent, Embed } from '@cashfree-intl/coherent';

import { EASY_SPLIT_VIDEO_LINK } from '../constants';

import useClickOutside from '../../../utils/hooks';

function EmbedModal({ closeModal }) {
  const modalRef = useRef(null);
  useClickOutside(modalRef, closeModal);

  return (
    <Modal open className="video-embed-modal" ref={modalRef}>
      <ModalContent>
        <Embed
          active
          placeholder="Easy Split by Cashfree Payments"
          url={EASY_SPLIT_VIDEO_LINK}
          autoplay
          iframe={{
            allowFullScreen: true,
          }}
        />
      </ModalContent>
    </Modal>
  );
}

EmbedModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default EmbedModal;
